import fetch from 'isomorphic-fetch';

/**
 * This function creates a fetch request with the given parameters.
 *
 * @param {Object} params - The parameters for the fetch request.
 * @param {string} params.token - The authorization token.
 * @param {string} params.url - The URL to send the request to.
 * @param {string} [params.method='GET'] - The HTTP method to use for the request.
 * @param {Object} [params.body=null] - The body of the request, which will be stringified to JSON.
 *
 * @returns {Promise} A Promise that resolves to the Response object representing the response to the request.
 */

const createFetch = ({
	token, url, method = 'GET', body = null,
}) => {
	const obj = {
		method,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	};

	if (body) {
		obj.body = JSON.stringify(body);
	}
	return fetch(url, obj);
};

export default createFetch;
